import { render, staticRenderFns } from "./tipDialog.vue?vue&type=template&id=7273eb98&scoped=true"
import script from "./tipDialog.vue?vue&type=script&lang=js"
export * from "./tipDialog.vue?vue&type=script&lang=js"
import style0 from "./tipDialog.vue?vue&type=style&index=0&id=7273eb98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273eb98",
  null
  
)

export default component.exports